
// CHECK THE MODULE HAVE PERMISSION
//SHOW MODULE that have at least one submodule.
export const isModulePermitted = (privileges = [], moduleName) => {
    return privileges?.some(module => module?.module_name === moduleName && module.submodules?.length > 0);
};

//-----------------------------------------------USING ID----------------------------


export const hasPrivilege = (privilegesData, moduleName, subModuleId, privilegeId) =>

    privilegesData.some(
        (item) =>
            item.module_name === moduleName &&
            item.submodules.some(
                (sub) =>
                    sub.submodule_id === subModuleId &&
                    sub.privileges.some((priv) => priv.id === privilegeId && priv.checked === 1)
            )
    );

//--------------------------------------------------END
/**
 * Retrieves modules  with their corresponding submodules that have at least one privilege.
 */
// export const getModuleWithPrivileges = (privileges) => {
//     // const privileges = getPrivilegesDetails();
//     const moduleMap = new Map();

//     privileges?.forEach(({ module_name, submodules }) => {
//         if (!moduleMap.has(module_name)) {
//             moduleMap.set(module_name, []);
//         }

//         submodules.forEach((sub) => {
//             if (sub.privileges.length >= 1) {
//                 moduleMap.get(module_name).push(sub.submodule_name);
//             }
//         });
//     });

//     return Array.from(moduleMap.entries()).map(([module, submodules]) => ({
//         module_name: module,
//         submodules,
//     }));
// };